import "./SentryInstrumentation";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./services/log/logger";

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);

/**
 * The app initially was deployed with a service worker, which will keep running and caching until you unregister it.
 */
async function unregisterServiceWorker(){
  if(!navigator || !navigator.serviceWorker){ return; } //native app issue
  const registrations = await navigator.serviceWorker.getRegistrations();
  for(const registration of registrations) {
    void registration.unregister();
  }
}

void unregisterServiceWorker();
